import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Title from "../../Title/Title";
import { fileURL, useFetch, usePOST } from "../../../ApiS";
import { Bounce, toast, ToastContainer } from "react-toastify";
import PasswordInput from "../../Inputs/Passwordinput";
import AddImage from "../../../ApiS/AddImage/AddImage";
import { useEffect, useRef, useState } from "react";
import Loader from "../../Loader";
import Selected from "../../Inputs/Selected";
import { AxiosError } from "axios";
import { Tooltip } from "react-tooltip";
import { FaCheck, FaEdit, FaTrash } from "react-icons/fa";

interface AcadimecFeeData {
  data: AcadimecFee;
}

interface AcadimecFee {
  curriculum_id?: string;
  student_year?: string;
  fee?: string;
  student_registrations_count?: string;
}
interface Error {
  curriculum_id?: string[];
  student_year?: string[];
  fee?: string[];
  student_registrations_count?: string[];
}

const Create_AcademicFee: React.FC = () => {
  const navigate = useNavigate();
  const { id, idd } = useParams();
  const enable = idd ? true : false;
  const { data, isLoading } = useFetch(
    `admin/semesters/${id}/academic-fees/${idd}`,
    `academic-fees${idd}`,
    enable
  );
  const notify = (message: string) => {
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };

  const [errors, setErrors] = useState<Error>({});

  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const { data: curriculums } = useFetch(
    "admin/curriculums?page=0",
    "admin/curriculums"
  );

  const [feeData, setFeeData] = useState<AcadimecFee>(data?.data!);
  const [fees, setFess] = useState<AcadimecFee[]>([]);

  const { handleSubmit, setFormData, handleChangeSelect, mutation } = usePOST(
    {},
    () => {
      navigate(-1);
    },
    (error) => {
      onError(error);
    }
  );
  const prepareFormData = () => {
    const formattedOptions = fees.reduce((acc, fees, index) => {
      return {
        ...acc,
        [`fees[${index}][curriculum_id]`]: fees?.curriculum_id,
        [`fees[${index}][student_year]`]: fees?.student_year,
        [`fees[${index}][fee]`]: fees?.fee,
        [`fees[${index}][student_registrations_count]`]:
          fees?.student_registrations_count,
      };
    }, {});
    const finalData = {
      ...formattedOptions,
      _method: idd ? "PUT" : "POST",
    };

    setFormData(finalData);
  };

  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [isEditing, setIsEditing] = useState(false);


  useEffect(() => {
    prepareFormData();
  }, [fees]);

  const handleSave = () => {
    if (
      !feeData?.curriculum_id ||
      !feeData?.student_year ||
      !feeData?.fee ||
      !feeData?.student_registrations_count
    ) {
      toast.error("يرجى ملء جميع الحقول المطلوبة");
      return;
    }

    if (editIndex !== null) {
      const updatedfees = [...fees];
      updatedfees[editIndex] = { ...fees[editIndex], ...feeData };
      setFess(updatedfees);
      toast.success("تم التحديث بنجاح");
    } else {
      setFess((prev) => [...prev, feeData]);
      toast.success("تم الحفظ بنجاح");
    }

    setFeeData({
      curriculum_id: "",
      student_year: "",
      fee: "",
      student_registrations_count: "",
    });
    setEditIndex(null);
  };

  const handleEdit = (index: number) => {
    setEditIndex(index);
    setFeeData(fees[index]);
    setIsEditing(true);

  };

  const handleDelete = (index: number) => {
    const updatedfees = fees.filter((_, i) => i !== index);
    setFess(updatedfees);
    toast.success("تم الحذف بنجاح");
  };

  const dataOld = data?.data;

  const sumbit = () => {
    handleSubmit(
      idd
        ? `admin/semesters/${id}/academic-fees/${idd}`
        : `admin/semesters/${id}/academic-fees`
    );
  };
  useEffect(() => {
    setFeeData(data?.data!);
  }, [data]);

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: id ? "هناك خطأ في عملية التعديل" : "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  const [PopUp, setPopUp] = useState(false);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Row>
        <Col lg={4} md={4}>
          <Title title={idd ? "تعديل  الرسوم" : "أنشاء  الرسوم"} />
        </Col>
      </Row>
      <ToastContainer position="bottom-left" />
      <Row justify={"around"}>
        <>
          <Col lg={5} md={5} sm={11}>
            <Selected
              title="المقرر"
              name="curriculum_id"
              text="أختر المقرر"
              value={feeData?.curriculum_id || ""}
              onChange={(e) => {
                setFeeData((prev) => ({
                  ...prev,
                  curriculum_id: e.target.value,
                }));
              }}
              className="!w-full max-lg:!w-full mb-5"
            >
              {!curriculums?.data?.data ? (
                <option disabled value="">
                  جارٍ تحميل المقررات...
                </option>
              ) : (
                curriculums.data.data.map((e: any) => (
                  <option key={e.id} value={e.id}>
                    {e.name_ar}
                  </option>
                ))
              )}
            </Selected>
            {errors?.curriculum_id &&
              errors?.curriculum_id.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={5} md={5} sm={11}>
            <Input
              type="date"
              name="student_year"
              onChange={(e) =>
                setFeeData((prev) => ({
                  ...prev,
                  student_year: e.target.value,
                }))
              }
              value={feeData?.student_year || ""}
              title="سنة الطالب"
              placeholder="ادخل سنة الطالب"
              className="!w-full"
            />
            {errors?.student_year &&
              errors?.student_year.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={5} md={5} sm={11}>
            <Input
              type="number"
              name="fee"
              onChange={(e) =>
                setFeeData((prev) => ({ ...prev, fee: e.target.value }))
              }
              title="المصاريف"
              placeholder="ادخل المصاريف"
              className="!w-full"
              value={feeData?.fee || ""}
            />
            {errors?.fee &&
              errors?.fee.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          <Col lg={5} md={5} sm={11}>
            <Input
              type="number"
              name="student_registrations_count"
              onChange={(e) =>
                setFeeData((prev) => ({
                  ...prev,
                  student_registrations_count: e.target.value,
                }))
              }
              title="عدد_تسجيلات_الطلاب"
              placeholder="ادخل عدد_تسجيلات_الطلاب"
              className="!w-full"
              value={feeData?.student_registrations_count || ""}
            />
            {errors?.student_registrations_count &&
              errors?.student_registrations_count.map((error, index) => (
                <p key={index} className="text-red-600 text-sm" dir="auto">
                  {error}
                </p>
              ))}
          </Col>
          {fees?.length > 0 && (
            <Col lg={5} md={5} sm={11}>
              <div
                className="cursor-pointer underline text-red-600"
                onClick={() => setPopUp(true)}
              >
                عرض الرسوم المنشأة
              </div>
            </Col>
          )}
        </>
      </Row>
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
      >
        <MainButton
          onClick={handleSave}
          titlebtn="انشاء"
          className={`w-[400px] ${idd ? "hidden" : ""} `}
        />
      </Col>
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
      >
        <MainButton
          onClick={sumbit}
          titlebtn="حفظ"
          className={`w-[400px] ${
            fees.length === 0 ? (idd ? "" : "hidden") : ""
          }  `}
        />
      </Col>

      {PopUp === true && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold !bg-black !bg-opacity-50"
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full max-lg:h-[70%] max-lg:overflow-y-scroll bg-white p-5 border-2 rounded-xl"
            >
              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="المقررات المدخلة" />
              </Col>

              {fees?.map((e, index) => (
                <>
                  <Col lg={10}>
                    <div className="flex justify-end">
                      <div id="Delete">
                        <FaTrash
                          size={25}
                          className="text-red-600 cursor-pointer hover:text-red-800 mx-10"
                          onClick={() => handleDelete(index)}
                        />
                      </div>
                      <div id="Edit">
                        {isEditing ? (
                          <FaCheck
                            size={25}
                            className="text-blue-600 cursor-pointer hover:text-green-800"
                          />
                        ) : (
                          <FaEdit
                            size={25}
                            className="text-blue-600 cursor-pointer hover:text-blue-800"
                            onClick={() => handleEdit(index)}
                          />
                        )}
                      </div>
                      <Tooltip
                        anchorSelect={`#Edit`}
                        style={{ background: "#475569" }}
                      >
                        <p>تمكين التعديل</p>
                      </Tooltip>
                      <Tooltip
                        anchorSelect={`#Delete`}
                        style={{ background: "#475569" }}
                      >
                        <p>حذف المقرر</p>
                      </Tooltip>
                    </div>
                  </Col>
                  <Col lg={5} md={5} sm={11}>
                    <Selected
                      title="المقرر"
                      name="curriculum_id"
                      text="أختر المقرر"
                      value={
                        editIndex === index
                          ? feeData.curriculum_id || ""
                          : e.curriculum_id || ""
                      }
                      onChange={(event) =>
                        setFeeData((prev) => ({
                          ...prev,
                          curriculum_id: event.target.value,
                        }))
                      }
                      className="!w-full max-lg:!w-full mb-5"
                    >
                      {!curriculums?.data?.data ? (
                        <option disabled value="">
                          جارٍ تحميل المقررات...
                        </option>
                      ) : (
                        curriculums.data.data.map((e: any) => (
                          <option key={e.id} value={e.id}>
                            {e.name_ar}
                          </option>
                        ))
                      )}
                    </Selected>
                  </Col>
                  <Col lg={5} md={5} sm={11}>
                    <Input
                      type="date"
                      name="student_year"
                      value={
                        editIndex === index
                          ? feeData.student_year || ""
                          : e.student_year || ""
                      }
                      onChange={(event) =>
                        setFeeData((prev) => ({
                          ...prev,
                          student_year: event.target.value,
                        }))
                      }
                      title="سنة الطالب"
                      placeholder="ادخل سنة الطالب"
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} md={5} sm={11}>
                    <Input
                      type="number"
                      name="fee"
                      value={
                        editIndex === index ? feeData.fee || "" : e.fee || ""
                      }
                      onChange={(event) =>
                        setFeeData((prev) => ({
                          ...prev,
                          fee: event.target.value,
                        }))
                      }
                      title="المصاريف"
                      placeholder="ادخل المصاريف"
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} md={5} sm={11}>
                    <Input
                      type="number"
                      name="student_registrations_count"
                      value={
                        editIndex === index
                          ? feeData.student_registrations_count || ""
                          : e.student_registrations_count || ""
                      }
                      onChange={(event) =>
                        setFeeData((prev) => ({
                          ...prev,
                          student_registrations_count: event.target.value,
                        }))
                      }
                      title="عدد_تسجيلات_الطلاب"
                      placeholder="ادخل عدد_تسجيلات_الطلاب"
                      className="!w-full"
                    />
                  </Col>

                  <Col lg={5} md={6} className="!mt-7">
                    <MainButton
                      onClick={handleSave}
                      titlebtn="تحديث"
                      className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                    />
                  </Col>
                  <Col
                    lg={5}
                    md={6}
                    className="!mt-7"
                    onClick={() => setEditIndex(null)}
                  >
                    <MainButton
                      titlebtn="رجوع"
                      onClick={() => setPopUp(false)}
                      className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                    />
                  </Col>
                </>
              ))}
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Create_AcademicFee;
